import { LoginTrendSeriesId } from '@/store/clientActivityApi';
import type { TrendSeries } from '@/models/ServiceTypes';

export interface MonthlyLogins {
  month: string;
  total: number;
  desktop: number;
  tablet: number;
  mobile: number;
}

function seriesValues(
  series: TrendSeries[],
  id: LoginTrendSeriesId,
): Map<string, number> {
  const target: number = id;
  const match = series.find((entry) => entry.id === target);
  const values = new Map<string, number>();
  if (!match) return values;
  for (const point of match.data) {
    values.set(point.Date, point.Value);
  }
  return values;
}

/**
 * Flattens the four parallel series the API returns into one row per month.
 *
 * The total series drives the month list, so a device series that is short or
 * missing leaves zeroes rather than shifting the chart: the months an advisor
 * sees always come from the number the line actually plots.
 */
export function toMonthlyLogins(
  series: TrendSeries[] | undefined,
): MonthlyLogins[] {
  if (!series || series.length === 0) return [];

  const totalId: number = LoginTrendSeriesId.Total;
  const total = series.find((entry) => entry.id === totalId);
  if (!total) return [];

  const desktop = seriesValues(series, LoginTrendSeriesId.Desktop);
  const tablet = seriesValues(series, LoginTrendSeriesId.Tablet);
  const mobile = seriesValues(series, LoginTrendSeriesId.Mobile);

  return total.data.map((point) => ({
    month: point.Date,
    total: point.Value,
    desktop: desktop.get(point.Date) ?? 0,
    tablet: tablet.get(point.Date) ?? 0,
    mobile: mobile.get(point.Date) ?? 0,
  }));
}
